import { Component, Input } from '@angular/core';
import { AvailabilityRoom1RateComponent } from '../availability-room-1-rate/availability-room-1-rate.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DisplayPricePipe } from '../../pipes/displayPrice';
import { AvailabilityDebugviewComponent } from "../availability-debugview/availability-debugview.component";
import { formatRateNamePipe } from "../../pipes/format-rate-name.pipe";
import { SettingsService } from 'core-lib';
import { TruncatedTextComponent } from '../truncated-text/truncated-text.component';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-availability-room-2-rate',
    imports: [ButtonModule, DisplayPricePipe, TranslateModule, AvailabilityDebugviewComponent, formatRateNamePipe, TruncatedTextComponent, TooltipModule],
    templateUrl: './availability-room-2-rate.component.html',
    styleUrl: './availability-room-2-rate.component.scss'
})
export class AvailabilityRoom2RateComponent extends AvailabilityRoom1RateComponent {
  
  @Input() isInAccordion:boolean = false;

  constructor(settings: SettingsService) {
    super(settings);
  }
}
